import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const InvitationResponseSchema = z.object({
    id: z.string(),
    publicKey: z.string(),
    ePrivateKeyByAdminKey: z.string(),
    ePrivateKeyByInvitationSecret: z.string(),
    ePrivateKeyBySsoSecret: z.string().nullish(),
    eInvitationSecretByAdminKey: z.string(),
    eWorkspaceCommonKeyByInvitationKey: z.string(),
    eEveryonePrivateKeyByInvitationKey: z.string(),
    sInvitationByAdminKey: z.string(),
    sAdminPublicKeyByInvitationKey: z.string(),
});
export class InvitationResponseDto extends createZodDto(InvitationResponseSchema) {
}
